var _g, _path, _mask, _g2, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 77.222 105.59",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffbd14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m52.71 105.57c-0.8175 0-1.5492-0.21-2.1951-0.63s-1.1563-1.03-1.5311-1.829c-0.3749-0.8-0.5624-1.771-0.5624-2.914 0-1.156 0.1897-2.131 0.5691-2.926 0.384-0.8 0.9011-1.403 1.5515-1.809 0.6504-0.411 1.3753-0.617 2.1748-0.617 0.6097 0 1.1111 0.104 1.5041 0.312 0.3929 0.203 0.7046 0.449 0.9349 0.738 0.2304 0.285 0.4088 0.554 0.5352 0.807h0.1017v-5.19h2.4594v13.875h-2.412v-1.639h-0.1491c-0.1264 0.252-0.3094 0.521-0.5487 0.806-0.2394 0.28-0.5556 0.519-0.9485 0.718-0.393 0.199-0.8876 0.298-1.4838 0.298zm0.6843-2.012c0.5194 0 0.9621-0.14 1.3279-0.42 0.3659-0.285 0.6436-0.68 0.8333-1.186s0.2846-1.095 0.2846-1.768-0.0949-1.258-0.2846-1.755c-0.1852-0.497-0.4607-0.883-0.8265-1.158-0.3614-0.276-0.8062-0.414-1.3347-0.414-0.5465 0-1.0027 0.143-1.3686 0.427-0.3658 0.285-0.6413 0.678-0.8265 1.179s-0.2778 1.075-0.2778 1.721c0 0.65 0.0926 1.231 0.2778 1.741 0.1897 0.506 0.4675 0.906 0.8333 1.199 0.3704 0.289 0.8243 0.434 1.3618 0.434z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.664 91.51v13.875h-2.4525v-13.875z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.481 105.59c-1.0163 0-1.897-0.223-2.6423-0.671-0.7452-0.447-1.3233-1.072-1.7344-1.876-0.4065-0.804-0.6097-1.744-0.6097-2.819s0.2032-2.016 0.6097-2.825c0.4111-0.808 0.9892-1.436 1.7344-1.883 0.7453-0.448 1.626-0.671 2.6423-0.671s1.897 0.223 2.6423 0.671c0.7452 0.447 1.3211 1.075 1.7276 1.883 0.411 0.809 0.6165 1.75 0.6165 2.825s-0.2055 2.015-0.6165 2.819c-0.4065 0.804-0.9824 1.429-1.7276 1.876-0.7453 0.448-1.626 0.671-2.6423 0.671zm0.0136-1.965c0.551 0 1.0117-0.151 1.3821-0.454 0.3703-0.307 0.6458-0.718 0.8265-1.233 0.1852-0.515 0.2778-1.088 0.2778-1.721 0-0.636-0.0926-1.212-0.2778-1.727-0.1807-0.52-0.4562-0.933-0.8265-1.24-0.3704-0.307-0.8311-0.461-1.3821-0.461-0.5646 0-1.0344 0.154-1.4093 0.461-0.3703 0.307-0.6481 0.72-0.8333 1.24-0.1806 0.515-0.271 1.091-0.271 1.727 0 0.633 0.0904 1.206 0.271 1.721 0.1852 0.515 0.463 0.926 0.8333 1.233 0.3749 0.303 0.8447 0.454 1.4093 0.454z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.28 95.941c-0.1129-0.366-0.2688-0.693-0.4675-0.982-0.1942-0.294-0.4291-0.545-0.7046-0.752-0.271-0.208-0.5826-0.364-0.9349-0.468-0.3523-0.108-0.7363-0.162-1.1518-0.162-0.7452 0-1.4092 0.187-1.9919 0.562-0.5826 0.375-1.041 0.926-1.3753 1.653-0.3297 0.723-0.4946 1.603-0.4946 2.642 0 1.048 0.1649 1.936 0.4946 2.663s0.7882 1.28 1.3753 1.66c0.5872 0.375 1.2692 0.562 2.0461 0.562 0.7046 0 1.3144-0.136 1.8293-0.407 0.5194-0.271 0.9191-0.654 1.1991-1.151 0.2801-0.502 0.4201-1.089 0.4201-1.762l0.5691 0.088h-3.7669v-1.964h5.63v1.666c0 1.188-0.2529 2.216-0.7588 3.083-0.5058 0.867-1.2014 1.536-2.0867 2.005-0.8853 0.465-1.9015 0.698-3.0487 0.698-1.2783 0-2.4007-0.287-3.3672-0.86-0.9621-0.578-1.7141-1.398-2.2561-2.46-0.5375-1.066-0.8062-2.33-0.8062-3.794 0-1.12 0.158-2.12 0.4742-3.001 0.3207-0.881 0.7678-1.628 1.3415-2.243 0.5736-0.618 1.2466-1.088 2.0189-1.409 0.7724-0.325 1.6125-0.488 2.5203-0.488 0.7679 0 1.4838 0.113 2.1477 0.339 0.664 0.221 1.2534 0.538 1.7683 0.949 0.5194 0.411 0.9462 0.898 1.2805 1.463 0.3342 0.565 0.5533 1.188 0.6571 1.87z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m77.222 38.611c0 21.324-17.287 38.611-38.611 38.611-21.324 0-38.611-17.287-38.611-38.611 0-21.324 17.287-38.611 38.611-38.611 21.324 0 38.611 17.287 38.611 38.611z",
    fill: "url(#paint0_linear_1699_3729)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1699_3729",
    x: 56,
    y: 28,
    width: 55,
    height: 56,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m110.9 55.69c0 15.106-12.246 27.352-27.352 27.352s-27.352-12.246-27.352-27.352 12.246-27.352 27.352-27.352 27.352 12.246 27.352 27.352z",
    fill: "#c28b37"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-43.648 -14.537)",
    mask: "url(#mask0_1699_3729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m109.45 52.772c0 15.106-12.246 27.352-27.352 27.352s-27.352-12.246-27.352-27.352 12.246-27.352 27.352-27.352 27.352 12.246 27.352 27.352z",
    fill: "url(#paint1_linear_1699_3729)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m39.627 18.289 6.4352 12.87 12.87 1.6088-8.8378 9.9102 2.4025 14.222-12.87-6.4352-12.87 6.4352 2.4239-14.222-8.8591-9.9102 12.87-1.6088z",
    fill: "url(#paint2_linear_1699_3729)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m39.627 16.258 7.0303 14.061 14.105 1.7631-9.6985 10.876 2.6278 15.556-14.064-7.0321-14.067 7.0335 2.6515-15.557-9.7223-10.876 14.108-1.7634zm-6.4352 14.902-12.87 1.6088 8.8591 9.9102-2.4239 14.222 12.87-6.4352 12.87 6.4352-2.4025-14.222 8.838-9.9102-12.871-1.6088-6.4352-12.87z",
    clipRule: "evenodd",
    fill: "#f4cc64",
    fillRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1699_3729",
    x1: 82.259,
    x2: 82.259,
    y1: 14.537,
    y2: 91.759,
    gradientTransform: "translate(-43.648 -14.537)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE284",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7B23F",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1699_3729",
    x1: 82.094,
    x2: 82.094,
    y1: 25.42,
    y2: 80.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE9A3",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC91D",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1699_3729",
    x1: 83.275,
    x2: 83.275,
    y1: 32.826,
    y2: 71.437,
    gradientTransform: "translate(-43.648 -14.537)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDF80",
    offset: 0.93229
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardGold);
export default __webpack_public_path__ + "static/media/reward-gold.bddf1a93e75000f1ad04826037c87023.svg";
export { ForwardRef as ReactComponent };